module.exports = __webpack_public_path__ + "static/media/instaperfect_logo_big.9f588110.png";